import React from "react";
import { BlockAbout } from "../components/BlockAbout";

const About = () => {
  return (
    <div className="containerColumns">
      <div className="leftColumn">
        <BlockAbout />
      </div>
      <div className="rightColumn">

      </div>
    </div>
  );
};

export default About;